import search from './search.vue'
const search_list = {
    install: function(Vue) {
        Vue.component('search_list', search)
    }
};
// 导出组件
export default search_list